<div class="faq">
  <button type="button" nz-button nzType="default" class="faq-trigger" (click)="showModal()">
    Как это работает? (FAQ)
  </button>
  <nz-modal
    [(nzVisible)]="isVisible"
    (nzOnCancel)="handleCancel()"
    (nzOnOk)="handleOk()"
    nzCentered
    [nzFooter]="null"
    nzClassName="faq-modal"
    nzWidth="600px"
  >
    <ng-container *nzModalContent>
      <div class="faq-modal-header">
        <div class="faq-modal-header__title">
          <img src="assets/icons/big_logo.svg" alt="big-logo" />
          <h1>BCC Business</h1>
        </div>
        <div class="faq-modal-header__description">
          <h2>Как это работает? (FAQ)</h2>
          <p>
            Мы хотим, чтобы вам было удобно пользоваться BCC Business. Выберите
            тот элемент, с которым вам нужна помощь.
          </p>
        </div>
      </div>

      <nz-spin [nzSpinning]="loading" class="mt_20">
        <app-faq-content
          *ngFor="let category of categories; let idx = index"
          [category]="category"
          [articles]="articles"
          [categories]="categories"
          [blockNumber]="idx + 1"
          [activeBlockNumber]="activeBlockNumber"
          (blockNumberEvent)="setActiveBlockNumber($event)"
        ></app-faq-content>
      </nz-spin>
    </ng-container>
  </nz-modal>
</div>
